import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && !e.target.dataset.counted) {
          e.target.dataset.counted = 'true'
          this.animate(e.target)
        }
      })
    }, { threshold: 0.5 })

    this.element.querySelectorAll('.counter').forEach(el => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  animate(el) {
    const target = parseInt(el.dataset.target)
    const duration = 2000
    const step = target / (duration / 16)
    let current = 0
    const timer = setInterval(() => {
      current += step
      if (current >= target) { current = target; clearInterval(timer) }
      el.textContent = Math.round(current)
    }, 16)
  }
}
